import React, { useState } from "react";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Checkbox } from "./ui/checkbox";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function DeleteAllCustomers({ onDone, trigger }) {
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState("");
  const [c1, setC1] = useState(false);
  const [c2, setC2] = useState(false);
  const start = () => { setPin(""); setC1(false); setC2(false); setOpen(true); };
  const submit = async () => {
    try {
      const r = await api.post("/customers/request-delete-all", { pin });
      toast.success(`${r.data.trashed} MÜŞTERİ ÇÖP KUTUSUNA ALINDI — ANA ADMİN ONAYINA GÖNDERİLDİ`);
      setOpen(false); onDone?.();
    } catch (e) { toast.error(e.response?.data?.detail || "HATA"); }
  };
  return (
    <>
      {trigger ? trigger(start) : (
        <button data-testid="delete-all-button" onClick={start} className="inline-flex items-center gap-1 text-xs font-medium text-rose-500/70 hover:text-rose-400">
          <Trash2 className="h-3.5 w-3.5" /> Tümünü sil (çöp kutusu + ana admin onayı)
        </button>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg border-rose-800 bg-slate-900 text-slate-100">
          <DialogHeader><DialogTitle className="font-head flex items-center gap-2 text-rose-300"><Trash2 className="h-5 w-5" /> TÜM MÜŞTERİLERİ SİLME TALEBİ</DialogTitle></DialogHeader>
          <div className="space-y-3 text-sm">
            <div className="rounded-lg border border-rose-900/50 bg-rose-950/30 p-3 text-rose-200">
              Bu işlem <b>hemen silmez</b>. Veriler önce çöp kutusuna alınır ve <b>nihai silme ANA ADMİN onayı</b> ile yapılır. Onaya kadar geri alabilirsiniz.
            </div>
            <label className="flex cursor-pointer items-start gap-2 text-slate-200">
              <Checkbox data-testid="delall-chk1" checked={c1} onCheckedChange={(v) => setC1(!!v)} />
              <span>Bu firmaya ait <b>tüm müşteri kayıtlarını</b> silme talebi oluşturmak istediğimi onaylıyorum.</span>
            </label>
            <label className="flex cursor-pointer items-start gap-2 text-slate-200">
              <Checkbox data-testid="delall-chk2" checked={c2} onCheckedChange={(v) => setC2(!!v)} />
              <span>Sorumluluğun firmama ait olduğunu <b>ikinci kez</b> onaylıyorum.</span>
            </label>
            <div className="space-y-1">
              <span className="text-xs text-slate-400">FİRMA PIN</span>
              <Input data-testid="delall-pin" type="password" inputMode="numeric" value={pin} onChange={(e) => setPin(e.target.value)} placeholder="PIN" className="h-10 border-slate-700 bg-slate-800 text-slate-100" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} className="border-slate-700 bg-slate-800 text-slate-200">VAZGEÇ</Button>
            <Button data-testid="delall-submit" disabled={!c1 || !c2 || !pin} onClick={submit} className="bg-rose-600 text-white hover:bg-rose-700 disabled:opacity-40">SİLME TALEBİ GÖNDER</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
